import type {ApolloCache} from '@apollo/client';

/**
 * Evicts every cached `AllRawTransactions` page scoped to a given account so
 * the next visit refetches from the network.
 *
 * Used after moving raw transactions into an account: that destination may
 * already have cached (and now stale) list pages from a prior visit. Because
 * the list query is cache-first, navigating back would otherwise reuse the
 * cached pages that omit the moved rows. We can't surgically insert into every
 * cached filter/pagination combination, so we drop them and let them reload.
 */
const evictAccountRawTransactions = (
  cache: ApolloCache<object>,
  accountId: string,
) => {
  cache.modify({
    fields: {
      // Store field names look like `allRawTransactions:{"accountId":"...",...}`;
      // drop this account's pages regardless of the other filter/pagination args.
      allRawTransactions: (existing: unknown, {storeFieldName, DELETE}) =>
        storeFieldName.includes(`"accountId":"${accountId}"`) ? DELETE : existing,
    },
  });
  cache.gc();
};

export default evictAccountRawTransactions;
